import { DASHBOARD_ISSUE_LIST } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DASHBOARD_ISSUE_LIST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DASHBOARD_ISSUE_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case DASHBOARD_ISSUE_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
